import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router";
import { createMicroApp, unmountMicroApp } from "@ice/stark";
import { Spin } from "antd";
import { findMenuTreeNode, registerSdk } from "@/utils";
import { getMenus } from "@/services";
import styles from "./index.module.css";

const ProcodePage = () => {
  const container = useRef(null);
  const location = useLocation();
  const path = location.pathname;
  const [isLoading, setIsLoading] = useState(false);

  /**
   * path变化时说明发生了页面切换,需要重新触发页面渲染
   */
  useEffect(() => {
    // 记录当前子应用的名称, 用于加载和卸载
    let currentAppName = "";

    const getPageInfo = async () => {
      const { menus } = await getMenus();
      const node = findMenuTreeNode(menus, path); // 找到这个path对应菜单项的详细信息

      const { appName, loadScriptMode, resources, basename } = node.extend;
      const url = JSON.parse(resources as string);

      currentAppName = (appName || path) as string;

      const client = await registerSdk;

      // 加载子应用
      await createMicroApp(
        {
          container: container.current,
          name: currentAppName,
          url,
          basename: basename as string,
          loadScriptMode: loadScriptMode as "fetch" | "script" | "import",
          sandbox: true,
          props: {
            sdkClient: client,
          },
        },
        {
          // beforeMount: (appConfig) => {
          //   console.log("beforeMount", appConfig);
          // },
          // afterMount: (appConfig) => {
          //   console.log("afterMount", appConfig);
          // },
          // beforeUnmount: (appConfig) => {
          //   console.log("beforeUnmount", appConfig);
          // },
          // afterUnmount: (appConfig) => {
          //   console.log("afterUnmount", appConfig);
          // },
        },
        {
          onLoadingApp: (appConfig) => {
            // console.log("onLoadingApp", appConfig);
            setIsLoading(true);
          },
          onFinishLoading: (appConfig) => {
            // console.log("onFinishLoading", appConfig);
            setIsLoading(false);
          },
          onError: (err) => {
            console.log("onError", err);
            setIsLoading(false);
          },
        },
      );
    };

    getPageInfo();

    return () => {
      // 卸载子应用
      unmountMicroApp(currentAppName);
    };
  }, [path]);

  return (
    <Spin tip="Loading..." spinning={isLoading}>
      <div key={path} className={styles.procodePage} ref={container}></div>
    </Spin>
  );
};

export default ProcodePage;
